import React from 'react'
import { ReactComponent as DocxIcon } from '../../assets/icons/file-format/docx.svg'
import { ReactComponent as PdfIcon } from '../../assets/icons/file-format/pdf.svg'
import { ReactComponent as JpgIcon } from '../../assets/icons/file-format/jpg.svg'
import { ReactComponent as PngIcon } from '../../assets/icons/file-format/png.svg'
import { ReactComponent as TxtIcon } from '../../assets/icons/file-format/txt.svg'
import { ReactComponent as XlsxIcon } from '../../assets/icons/file-format/xls.svg'
import { ReactComponent as CsvIcon } from '../../assets/icons/file-format/csv.svg'
import { ReactComponent as ZipIcon } from '../../assets/icons/file-format/zip.svg'
import { ReactComponent as XlsIcon } from '../../assets/icons/file-format/xls.svg'
import { ReactComponent as CdrIcon } from '../../assets/icons/file-format/cdr.svg'
import { ReactComponent as CabIcon } from '../../assets/icons/file-format/cab.svg'
import { ReactComponent as RawIcon } from '../../assets/icons/file-format/raw.svg'
import { ReactComponent as PhpIcon } from '../../assets/icons/file-format/php.svg'
import { ReactComponent as PptIcon } from '../../assets/icons/file-format/ppt.svg'
import { ReactComponent as PptxIcon } from '../../assets/icons/file-format/pptx.svg'
import { ReactComponent as ObjIcon } from '../../assets/icons/file-format/obj.svg'
import { ReactComponent as UrlIcon } from '../../assets/icons/file-format/url.svg'
import { ReactComponent as AviIcon } from '../../assets/icons/file-format/avi.svg'
import { ReactComponent as EpsIcon } from '../../assets/icons/file-format/eps.svg'
import { ReactComponent as CssIcon } from '../../assets/icons/file-format/css.svg'
import { ReactComponent as HtmlIcon } from '../../assets/icons/file-format/html.svg'
import { ReactComponent as FlaIcon } from '../../assets/icons/file-format/fla.svg'
import { ReactComponent as FlvIcon } from '../../assets/icons/file-format/flv.svg'
import { ReactComponent as CppIcon } from '../../assets/icons/file-format/cpp.svg'
import { ReactComponent as MpgIcon } from '../../assets/icons/file-format/mpg.svg'
import { ReactComponent as IdIcon } from '../../assets/icons/file-format/id.svg'
import { ReactComponent as IsoIcon } from '../../assets/icons/file-format/iso.svg'
import { ReactComponent as TifIcon } from '../../assets/icons/file-format/tif.svg'
import { ReactComponent as WavIcon } from '../../assets/icons/file-format/wav.svg'
import { ReactComponent as ThdsIcon } from '../../assets/icons/file-format/3ds.svg'
import { ReactComponent as MovIcon } from '../../assets/icons/file-format/mov.svg'
import { ReactComponent as AiIcon } from '../../assets/icons/file-format/ai.svg'
import { ReactComponent as SvgIcon } from '../../assets/icons/file-format/svg.svg'
import { ReactComponent as XlrIcon } from '../../assets/icons/file-format/xlr.svg'
import { ReactComponent as IcoIcon } from '../../assets/icons/file-format/ico.svg'
import { ReactComponent as TtfIcon } from '../../assets/icons/file-format/ttf.svg'
import { ReactComponent as DllIcon } from '../../assets/icons/file-format/dll.svg'
import { ReactComponent as XxlIcon } from '../../assets/icons/file-format/xxl.svg'
import { ReactComponent as SqlIcon } from '../../assets/icons/file-format/sql.svg'
import { ReactComponent as BmpIcon } from '../../assets/icons/file-format/bmp.svg'
import { ReactComponent as CadIcon } from '../../assets/icons/file-format/cad.svg'
import { ReactComponent as ExeIcon } from '../../assets/icons/file-format/exe.svg'
import { ReactComponent as RarIcon } from '../../assets/icons/file-format/rar.svg'
import { ReactComponent as ApkIcon } from '../../assets/icons/file-format/apk.svg'
import { ReactComponent as XmlIcon } from '../../assets/icons/file-format/xml.svg'
import { ReactComponent as PsdIcon } from '../../assets/icons/file-format/psd.svg'
import { ReactComponent as OtfIcon } from '../../assets/icons/file-format/otf.svg'
import { ReactComponent as InddIcon } from '../../assets/icons/file-format/indd.svg'
import { ReactComponent as Mp4Icon } from '../../assets/icons/file-format/mp4.svg'
import { ReactComponent as TiffIcon } from '../../assets/icons/file-format/tiff.svg'
import { ReactComponent as JsIcon } from '../../assets/icons/file-format/js.svg'
import { ReactComponent as ThreegpIcon } from '../../assets/icons/file-format/3gp.svg'
import { ReactComponent as Mp3Icon } from '../../assets/icons/file-format/mp3.svg'
import { ReactComponent as XdIcon } from '../../assets/icons/file-format/xd.svg'
import { ReactComponent as GifIcon } from '../../assets/icons/file-format/gif.svg'
import { ReactComponent as BatIcon } from '../../assets/icons/file-format/bat.svg'
import { InsertDriveFile } from '@mui/icons-material'

export const FILE_ICONS: Record<string, any> = {
	// Documents
	doc: DocxIcon,
	docx: DocxIcon,
	pdf: PdfIcon,
	ppt: PptIcon,
	pptx: PptxIcon,
	txt: TxtIcon,
	rtf: TxtIcon,
	html: HtmlIcon,
	xml: XmlIcon,
	js: JsIcon,
	css: CssIcon,
	php: PhpIcon,

	// Spreadsheets
	xls: XlsIcon,
	xlsx: XlsxIcon,
	csv: CsvIcon,
	xlr: XlrIcon,
	xxl: XxlIcon,

	// Images
	jpg: JpgIcon,
	jpeg: JpgIcon,
	png: PngIcon,
	gif: GifIcon,
	svg: SvgIcon,
	webp: PngIcon,
	raw: RawIcon,
	psd: PsdIcon,
	ai: AiIcon,
	eps: EpsIcon,
	bmp: BmpIcon,
	tif: TifIcon,
	tiff: TiffIcon,
	ico: IcoIcon,

	// Video
	avi: AviIcon,
	mp4: Mp4Icon,
	mov: MovIcon,
	flv: FlvIcon,
	mpg: MpgIcon,
	'3gp': ThreegpIcon,

	// Audio
	mp3: Mp3Icon,
	wav: WavIcon,

	// Design
	cdr: CdrIcon,
	id: IdIcon,
	indd: InddIcon,
	xd: XdIcon,
	fla: FlaIcon,

	// Development
	cpp: CppIcon,
	dll: DllIcon,
	exe: ExeIcon,
	apk: ApkIcon,
	bat: BatIcon,

	// 3D
	obj: ObjIcon,
	'3ds': ThdsIcon,

	// Fonts
	ttf: TtfIcon,
	otf: OtfIcon,

	// Archives
	zip: ZipIcon,
	rar: RarIcon,
	'7z': ZipIcon,
	tar: ZipIcon,
	gz: ZipIcon,
	cab: CabIcon,
	iso: IsoIcon,

	// Other
	sql: SqlIcon,
	cad: CadIcon,
	url: UrlIcon,

	// Default icon for unknown types
	default: InsertDriveFile,
}

const getFileIcon = (
	extension?: string
): React.FC<React.SVGProps<SVGSVGElement>> | typeof InsertDriveFile => {
	if (!extension) return InsertDriveFile
	const normalizedExt = extension.toLowerCase().replace('.', '')
	return FILE_ICONS[normalizedExt] || InsertDriveFile
}

export default getFileIcon
